export default {
  mounted() {
    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        // Extract all phx-value-* attributes and pass them as parameters
        const params = {};
        for (const attr of this.el.attributes) {
          if (attr.name.startsWith('phx-value-')) {
            const key = attr.name.replace('phx-value-', '');
            params[key] = attr.value;
          }
        }
        
        // If we have any group parameters, use load-more-group, otherwise load-more
        if (Object.keys(params).length > 0) {
          this.pushEventTo(this.el, "load-more-group", params);
        } else {
          this.pushEventTo(this.el, "load-more", {});
        }
      }
    }, { threshold: 0.1 });

    this.observer.observe(this.el.querySelector(".scroll-trigger"));
  },
  destroyed() {
    this.observer.disconnect();
  }
}
